// src/apiService.js
import api from './api';

export async function sendRequest(url, method, data = {}) {
  try {
    const config = {
      method: method,
      url: url,
      headers: {
        'Content-Type': 'application/json'
      }
    };

    if (method === 'GET') {
      config.params = data; // 将 data 作为查询参数
    } else {
      config.data = data; // 将 data 作为请求体
    }

    const response = await api(config);
    return response.data;
  } catch (error) {
    console.error(`Request failed: ${error}`);
    throw error;
  }
}

export async function loginByUnionid(loginInfo) {
  
  return await sendRequest('user/login/by/unionid', 'POST', loginInfo);
}

export async function getUserCoinInfoListPagedById(pageParams) {
  return await sendRequest('usercoin/get/coin/info/paged', 'GET',pageParams);
}

export async function getUserCoinCount() {
  return await sendRequest('usercoin/total/coin', 'GET');
}


export async function getUserEquipmentItems() {
  return await sendRequest('user/equipment/get', 'GET');
}

export async function getstudyData() {
  return await sendRequest('usercoin/get/study/data', 'GET');
}

